import { Component, ElementRef, EventEmitter, HostListener, Input, Output, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { InfoButtonComponent } from '@app/components/info-modal/info-button/info-button.component';
import { ModalComponent } from '@app/components/info-modal/modal/modal.component';
import { ModalItem } from '@app/models/elements/modal-item';
import { FilterStatus } from '@app/models/filters/filter-status';
import { GenericFilterConfig } from '@app/models/filters/generic-filter-config';
import { MultiValueFilterConfig } from '@app/models/filters/multi-value-filter-config';

@Component({
	selector: 'app-multi-select',
	standalone: true,
	imports: [InfoButtonComponent, FormsModule, ModalComponent],
	templateUrl: './multi-select.component.html',
	styleUrl: './multi-select.component.css',
})
export class MultiSelectComponent {
	@Input() genericConfig: GenericFilterConfig = {} as GenericFilterConfig;
	specificConfig: MultiValueFilterConfig = {} as MultiValueFilterConfig;

	@Output() optionChanged = new EventEmitter<FilterStatus>();

	@ViewChild('multiSelect') multiSelect!: ElementRef;

	selectedValuesLabel: string[] = [];
	selectedValuesLabelModal: ModalItem = {
		header: 'Valori selezionati',
		body: 'Nessuno',
	};
	numberOfSelected: number = 0;

	ngOnInit() {
		this.specificConfig = this.genericConfig as MultiValueFilterConfig;

		// set modal content with default selected values
		this.selectedValuesLabel = [];
		for (let option of this.specificConfig.options) {
			if (
				this.specificConfig.defaultValues.includes(option.primaryValue) ||
				this.specificConfig.defaultValues.includes(option.secondaryValue)
			) {
				this.selectedValuesLabel.push(option.label);
			}
		}
		this.selectedValuesLabelModal = {
			...this.selectedValuesLabelModal,
			body: this.selectedValuesLabel.length > 0 ? this.selectedValuesLabel.join(', ') : 'Nessuno.',
		};

		this.numberOfSelected = this.specificConfig.defaultValues.length;
	}

	ngOnChanges() {
		this.specificConfig = this.genericConfig as MultiValueFilterConfig;

		// when the list of options changes (e.g. when a provincia is selected/unselected)
		// clean the list of selected va
		if (this.multiSelect) {
			// get all children checkboxes
			let checkboxes = this.multiSelect.nativeElement.querySelectorAll('input[type="checkbox"]');
			checkboxes.forEach((checkbox: HTMLInputElement) => (checkbox.checked = false));

			this.selectedValuesLabel = [];
			for (let option of this.specificConfig.options) {
				if (
					this.specificConfig.defaultValues.includes(option.primaryValue) ||
					this.specificConfig.defaultValues.includes(option.secondaryValue)
				) {
					this.selectedValuesLabel.push(option.label);
				}
			}
			this.selectedValuesLabelModal = {
				...this.selectedValuesLabelModal,
				body: this.selectedValuesLabel.length > 0 ? this.selectedValuesLabel.join(', ') : 'Nessuno.',
			};

			this.numberOfSelected = this.specificConfig.defaultValues.length;
		}
	}

	onOptionChange = (checkboxValue: string) => {
		let checkboxes = this.multiSelect.nativeElement.querySelectorAll('input[type="checkbox"]');
		let checkedCheckboxes: any[] = Array.from(checkboxes).filter((checkbox: any) => checkbox.checked);
		let selectedPrimaryValues = checkedCheckboxes.map((c: any) => c.value);
		let selectedSecondaryValues = checkedCheckboxes.map((c: any) => c.getAttribute('secondaryValue'));

		if (this.specificConfig.maxSelected != null && selectedPrimaryValues.length > this.specificConfig.maxSelected) {
			// unselect last selected option
			for (let cc of checkedCheckboxes) {
				if (cc.value === checkboxValue) {
					cc.checked = false;
				}
			}
			alert('Hai raggiunto il limite massimo di valori selezionati.');
			return;
		}

		// fill selected values modal
		this.numberOfSelected = selectedPrimaryValues.length;
		this.selectedValuesLabel = this.getLabelsFromPrimaryValues(selectedPrimaryValues);
		this.selectedValuesLabelModal = {
			...this.selectedValuesLabelModal,
			body: this.selectedValuesLabel.length > 0 ? this.selectedValuesLabel.join(', ') : 'Nessuno.',
		};

		this.optionChanged.emit({
			filterId: this.specificConfig.id,
			selectedPrimaryValues: selectedPrimaryValues,
			selectedSecondaryValues: selectedSecondaryValues,
		});
	};

	private getLabelsFromPrimaryValues(primaryValues: string[]) {
		return this.specificConfig.options.filter((o) => primaryValues.includes(o.primaryValue)).map((fo) => fo.label);
	}
}
